import { ordinalSuffix } from 'utils/functions/ordinalSuffix';
import { $t } from 'utils/functions/translate';

export const getPositionOptionLabel = (positionOptionValue: number, afterRef: string): string => {
  return `${positionOptionValue + 1}${$t(ordinalSuffix(positionOptionValue + 1))} (${$t('after')} ${afterRef})`;
};
